import { Model } from '@/models/Model';

export class Task extends Model {
  protected $name = 'Task';

  protected $endpoint = '/hin/tasks';

  protected $primaryKey = 'id';

  protected $fillable: string[] = ['status_raw'];

  public uuid?: string;

  public status_raw?: string;

  public sub_tasks?: this[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public prices?: Record<any, any>[];

  public updateStatus(status: string): Promise<void> {
    const url = `${this.$endpoint}/${this.uuid}`;
    return this.request('patch', url, { status });
  }

  public listTasks(report: string, isSubTask: boolean): Promise<Task[]> {
    const filters = {
      report,
      isSubTask: isSubTask ? 1 : 0,
    };
    return this.request('get', this.$endpoint, { filters }, '');
  }
}
